import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, FormGroup, Link, makeStyles, Typography } from '@material-ui/core';
import { useUrlState } from '@zennya/web-component-library/src';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import { testLogEventWhitelabel } from 'services/authentication.service';
import { fetchEULA } from 'services/partnerSettings';
import { HelvNeue } from 'themes/theme';
import { useTrackEvent, useTrackPage } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    helv: {
      fontFamily: HelvNeue
    },
    form: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    fcl: {
      textAlign: 'left',

    },
    fInput: {
      padding: theme.spacing(2),
    }
  }
})
const PrivacyPolicyPage = ({ serviceId, bookingData, whiteLabelPartner, onComplete = () => { } }) => {
  const classes = useStyles()
  const [TOC, setTOC] = useState(false);
  const [privPolicy, setPrivPolicy] = useState(false);

  const [legalURLs, setLegalURLs] = useState(null);

  const trackEvent = useTrackEvent(serviceId)
  const pageViewed = useTrackPage(serviceId)

  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
  });

  const fetchWLSettings = useCallback(
    async () => {
      try {
        const toc = whiteLabelPartner?.agreements?.find((agreement) => agreement?.type === 'TERMS')
        const priv = whiteLabelPartner?.agreements?.find((agreement) => agreement?.type === 'PRIVACY')
        setLegalURLs({
          toc,
          priv,
        })
      } catch (error) {
        
      }
    }, [whiteLabelPartner]
  );

  useEffect(
    () => {
      fetchWLSettings()
    }, [whiteLabelPartner?.id]
  );

  useEffect(() => {
    async function track() {
      pageViewed('Terms', { })
      testLogEventWhitelabel(serviceId, medium, `[customer-${bookingData?.customer?.id}] opened whitelabel booking web app`)
    }
    if (bookingData) {
      track()
    }
  }, [bookingData]);
  if (!whiteLabelPartner?.label) {
    return <CircularProgress/>
  }

  const tocAgreement = whiteLabelPartner?.agreements?.find(a => a.type === 'TERMS')?.url
  const privpolAgreement = whiteLabelPartner?.agreements?.find(a => a.type === 'PRIVACY')?.url
  
  return (
    <>
      <Typography className={classes.helv} variant="h3">{whiteLabelPartner?.label ??
        "{{STUB}}"}  requested a service for you</Typography>
      <Card elevation={3}>
        <CardContent>
          <Typography gutterBottom variant="body1">Click continue to verify the client information, location, date and time of your booking.<br/><br/>Once you have confirmed that all details are correct, we will look for a provider to perform the service. Until then, your booking is not yet confirmed until you receive a confirmation message.</Typography>

          <FormGroup className={classes.form}>
            <FormControlLabel
              className={classes.fcl}
              control={<Checkbox checked={TOC} onChange={() => {
                setTOC(true)
                trackEvent('Terms - zennya terms - checked', { booking_id: serviceId })
              }} name="checkedToc" />}
              label={
                <Typography className={classes.fInput}>
                  I agree to the
                  &nbsp;
                  <Link href="https://www.zennya.com/legal/terms-of-service" target="_ext"
                    onClick={() => {
                      trackEvent('Terms - zennya terms - opened', { booking_id: serviceId, link: 'https://www.zennya.com/legal/terms-of-service' })
                    }}
                  >Terms of Service</Link> and
                  &nbsp;
                  <Link href="https://www.zennya.com/legal/privacy-policy" target="_ext"
                    onClick={() => {
                      trackEvent('Terms - zennya privacy policy - opened', { booking_id: serviceId, link: 'https://www.zennya.com/legal/privacy-policy' })
                    }}>Privacy Policy</Link>
                  &nbsp; of Zennya
                </Typography>}
            />
            <FormControlLabel
              className={classes.fcl}
              control={<Checkbox checked={privPolicy} onChange={() => {
                setPrivPolicy(true)
                trackEvent(`Terms - ${whiteLabelPartner?.name} terms - checked`, { booking_id: serviceId })
              }} name="checkedPriv" />}
              label={
                <Typography className={classes.fInput}>
                  I agree to the
                  &nbsp;
                  <Link href={legalURLs?.toc?.url} target="_ext"
                    onClick={() => {
                      trackEvent(`Terms - ${whiteLabelPartner?.name} ${legalURLs?.toc?.type} - opened`, { booking_id: serviceId, link: legalURLs?.terms_of_service_url })
                    }}>{legalURLs?.toc?.label}</Link> and
                  &nbsp;
                  <Link href={legalURLs?.priv?.url} target="_ext"
                    onClick={() => {
                      trackEvent(`Terms - ${whiteLabelPartner?.name} ${legalURLs?.priv?.type} - opened`, { booking_id: serviceId, link: legalURLs?.privacy_policy_url })
                    }}>{legalURLs?.priv?.label}</Link>
                  &nbsp; of {whiteLabelPartner?.label}
                </Typography>}
            />
          </FormGroup>
          <Button fullWidth variant="contained" color="primary" onClick={() => {
            onComplete()
            trackEvent("Terms - Continue - click", { booking_id: serviceId })
          }} disabled={!TOC || !privPolicy}>Continue</Button>

        </CardContent>
      </Card>
    </>
  )
}

export { PrivacyPolicyPage }